import { STPresetLineDashVal } from '@tencent/slide-sdk-model';

// 短划线类型 - sdk对上层类型映射（office支持显示有11种，下拉编辑的有8种。我们显示和下拉编辑均只支持这8种，所以剩下3个降级为相近支持的）
export const LINE_DASH_VER3_MAP = new Map([
    [STPresetLineDashVal?.solid, 'solid'],
    [STPresetLineDashVal?.dot, 'dot'], // 上层无对应实现，降级为sysDot
    [STPresetLineDashVal?.dash, 'dash'],
    [STPresetLineDashVal?.lgDash, 'lgDash'],
    [STPresetLineDashVal?.dashDot, 'dashDot'],
    [STPresetLineDashVal?.lgDashDot, 'lgDashDot'],
    [STPresetLineDashVal?.lgDashDotDot, 'lgDashDotDot'],
    [STPresetLineDashVal?.sysDash, 'sysDash'],
    [STPresetLineDashVal?.sysDot, 'sysDot'],
    [STPresetLineDashVal?.sysDashDot, 'sysDashDot'], // 上层无对应实现，降级为SysDash
    [STPresetLineDashVal?.sysDashDotDot, 'sysDashDotDot'], // 上层无对应实现，降级为SysDash
]);
